import React from 'react';
import I18n from 'i18n-js';

import { RCMenu, RCIcon } from '@reverbdotcom/cadence/components';
import { CheckCircleIcon } from '@phosphor-icons/react';

import { SellerListing } from '../sellerListingsCollectionReducer';
import { usePublishListing } from './usePublishListing';

export const COMPONENT_NAME = 'PublishButton';
interface IExternalProps {
  listing: SellerListing;
  insightsVariant?: boolean;
}

function PublishButton({ listing, insightsVariant }: IExternalProps) {
  const { publish, isPublishing, canPublish } = usePublishListing({
    listing,
    componentName: COMPONENT_NAME,
  });

  if (insightsVariant) {
    return <RCMenu.Item
      onClick={publish}
      disabled={!canPublish || isPublishing}
      icon={<CheckCircleIcon />}
    >
      {I18n.t('discovery.listingsManagement.sellerListingCard.publish')}
    </RCMenu.Item>;
  }

  return (
    <RCMenu.Item
      onClick={publish}
      disabled={!canPublish || isPublishing}
    >
      {I18n.t('discovery.listingsManagement.sellerListingCard.publish')}
      <RCIcon icon={<CheckCircleIcon />} size="inline" spacing="left" />
    </RCMenu.Item>
  );
}

export default PublishButton;
